import React, { useEffect, useState } from 'react'
import Modal from 'components/modal'
import 'less/scheduler/combined-availability-warning-modal.less'


const CombinedAvailabilityWarningModal = props => {
  const [timeslot, setTimeslot] = useState(props.timeSlot)

  useEffect(() => {
    if (props.timeSlot) {
      setTimeslot(props.timeSlot)
    }
  }, [props.timeSlot])

  const onSubmit = () => {
    props.toggleCombinedAbWarningModal(timeslot.timeSlotId)
    props.onSubmit(timeslot.timeSlotId)
  }
  return (
    <Modal
      title={"Edit & Manage Interview"}
      isOpen={props.isOpen}
      className="confirmation-modal combined-availability-warning-modal"
      type="modal"
      autoFocusSubmit={false}
      submitBtnText="Ok"
      onCancel={props.onClose}
      onSubmit={() => onSubmit()}
    >
      <div className="combined-availability-warning-modal-body">
        <div className="combined-availability-warning-modal-text">
          <p>
            {props.t('warning.message')}
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default CombinedAvailabilityWarningModal
